// Rastreamento de origem de tráfego para os CTAs de compra (Monetizze).
// Não altera design/textos/estrutura — apenas resolve o link de destino.

const ORIGEM_LINKS = {
  meta: "https://pay.monetizze.com.br/DXR386022?mcr=BFS1905520",
  google: "https://pay.monetizze.com.br/DXR386022?mcr=BNF1905521",
  facebook: "https://pay.monetizze.com.br/DXR386022?mcr=BDC1905522",
  tiktok: "https://pay.monetizze.com.br/DXR386022?mcr=BMS1905523",
};

const DEFAULT_LINK = "https://pay.monetizze.com.br/DXR386022?mcr=ASP25837414";

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

// Parâmetros repassados ao checkout (UTMs + click ids do Google Ads e Meta Ads).
const PASSTHROUGH_KEYS = [...UTM_KEYS, "gclid", "fbclid"];

const ORIGEM_STORAGE_KEY = "origem";
const UTM_STORAGE_KEY = "utms";

function readStorage(key) {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    return null;
  }
}

function writeStorage(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    /* localStorage indisponível — ignora */
  }
}

// Captura a origem e UTMs da URL atual e persiste no navegador (uma vez, na entrada).
export function captureTracking() {
  const params = new URLSearchParams(window.location.search);

  const origem = (params.get("origem") || "").toLowerCase().trim();
  if (origem && ORIGEM_LINKS[origem]) {
    writeStorage(ORIGEM_STORAGE_KEY, origem);
  }

  const utms = {};
  PASSTHROUGH_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) utms[k] = v;
  });
  if (Object.keys(utms).length) {
    writeStorage(UTM_STORAGE_KEY, JSON.stringify(utms));
  }
}

// Resolve o link de checkout com base na origem (URL > localStorage > padrão),
// preservando UTMs quando presentes.
export function getCheckoutUrl() {
  const params = new URLSearchParams(window.location.search);

  let origem = (params.get("origem") || "").toLowerCase().trim();
  if (!origem || !ORIGEM_LINKS[origem]) {
    origem = (readStorage(ORIGEM_STORAGE_KEY) || "").toLowerCase().trim();
  }

  const base = ORIGEM_LINKS[origem] || DEFAULT_LINK;

  // UTMs/gclid da URL atual têm prioridade; senão usa os persistidos.
  let utms = {};
  PASSTHROUGH_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) utms[k] = v;
  });
  if (!Object.keys(utms).length) {
    try {
      utms = JSON.parse(readStorage(UTM_STORAGE_KEY) || "{}") || {};
    } catch (e) {
      utms = {};
    }
  }

  const src = getCheckoutSrc();
  if (src) utms = { ...utms, src };

  const qs = new URLSearchParams(utms).toString();
  if (!qs) return base;
  const sep = base.includes("?") ? "&" : "?";
  return `${base}${sep}${qs}`;
}

// Retorna a origem resolvida (URL > localStorage > "padrao") — usada no relatório.
export function getOrigem() {
  const params = new URLSearchParams(window.location.search);
  let origem = (params.get("origem") || "").toLowerCase().trim();
  if (!origem || !ORIGEM_LINKS[origem]) {
    origem = (readStorage(ORIGEM_STORAGE_KEY) || "").toLowerCase().trim();
  }
  return ORIGEM_LINKS[origem] ? origem : "padrao";
}

// ---- Consentimento + atribuição OpenAI Ads ----
const CONSENT_KEY = "cookie_consent";
const SRC_KEY = "checkout_src";
const OPPREF_KEY = "oai_oppref";

export function getConsent() {
  return readStorage(CONSENT_KEY);
}

export function setConsent(granted) {
  writeStorage(CONSENT_KEY, granted ? "granted" : "denied");
  if (typeof window.oaiq === "function") window.oaiq("consent", !!granted);
  if (granted) {
    if (typeof window.oaiq === "function" && !window.__oaiqPageViewed) {
      window.__oaiqPageViewed = true;
      window.oaiq("measure", "page_viewed", { type: "contents", contents: [{ id: "landing", name: "Aprenda a Falar com Deus", content_type: "page" }] });
    }
    const oppref = new URLSearchParams(window.location.search).get("oppref");
    if (oppref) writeStorage(OPPREF_KEY, oppref);
  } else {
    try { localStorage.removeItem(SRC_KEY); localStorage.removeItem(OPPREF_KEY); } catch (e) { /* noop */ }
  }
}

function randomHex(bytes) {
  const arr = new Uint8Array(bytes);
  window.crypto.getRandomValues(arr);
  return Array.from(arr, (b) => b.toString(16).padStart(2, "0")).join("");
}

// Código interno aleatório (sem dados pessoais) — só existe com consentimento.
export function getCheckoutSrc() {
  if (getConsent() !== "granted") return null;
  let src = readStorage(SRC_KEY);
  if (!src) {
    src = `ck_${randomHex(16)}`;
    writeStorage(SRC_KEY, src);
  }
  return src;
}

function readCookie(name) {
  const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return m ? decodeURIComponent(m[1]) : null;
}

// Envia ao backend a associação src -> identificadores do Pixel OpenAI (somente com consentimento).
export function recordCheckoutAttribution(backendUrl) {
  const src = getCheckoutSrc();
  if (!src) return;
  const oppref = readCookie("__oppref") || new URLSearchParams(window.location.search).get("oppref") || readStorage(OPPREF_KEY);
  const body = JSON.stringify({
    src,
    consent: true,
    oppref: oppref || null,
    obref: readCookie("__obref"),
    source_url: window.location.origin + window.location.pathname,
  });
  try {
    fetch(`${backendUrl}/api/attribution/checkout`, {
      method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true,
    }).catch(() => {});
  } catch (e) { /* noop */ }
}
